<template>
  <div>
    <div class="banner p1-3 mt-3">Our Leadership Team</div>
    <div class="section-container">
      <div class="container text-center">
        <div class="row">
          <!-- 'row' for horizontal, 'wrap' to stack on small screens -->
          <div class="col-12 col-md-6">
            <p>
              At PGP Title, our leaders are dedicated to supporting our
              PulteGroup partners and ensuring a seamless, secure closing
              experience for every homebuyer. With decades of experience, our
              leaders help ensure that the final step of the homebuying journey
              is smooth and celebratory!
            </p>
            <button
              class="btn btn-primary btn-lg btn-pulte"
              @click="
                openInNewTab(
                  'https://pultegroupinc.com/about/management/default.aspx',
                )
              "
            >
              PulteGroup Leadership
            </button>
          </div>
          <div class="col-12 col-md-6 section-image-container">
            <div style="width: 100%">
              <img src="../../assets/images/pgptitle-building.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CARDS GO HERE -->
    <div class="container" ref="seniorLeadership">
      <h2>Senior Leadership at PGP Title</h2>
      <LeadershipCards @select="onLeadershipClick"></LeadershipCards>
    </div>

    <div class="section-container">
      <div class="container text-center">
        <div class="row">
          <!-- 'row' for horizontal, 'wrap' to stack on small screens -->
          <div class="col-12 col-md-6">
            <h5 class="subheadline">People First, Always</h5>
            <p>
              We believe great people build great companies. If you're looking
              for a wokplace that values collabration and growth, you've come to
              the right place.
            </p>
            <button
              class="btn btn-primary btn-lg btn-pulte"
              @click="
                openInNewTab('https://pultegroup.wd1.myworkdayjobs.com/PGI')
              "
            >
              Our Career Opportunities
            </button>
          </div>
          <div class="col-12 col-md-6 section-image-container">
            <div style="width: 100%">
              <img src="../../assets/images/collaboration.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <LeadershipModal ref="leadershipModal"></LeadershipModal>
  </div>
</template>

<style scoped>
div {
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  text-align: left;
}

h2 {
  font-size: 30px;
  margin: 0 0 8px;
  font-weight: bold;
}

p {
  font-size: 16px;
  color: #202a2f;
  margin: 0 0 16px;
}

.section-container {
  background-color: #fff;
}

.section-image-container > div {
  text-align: right;
}
.section-image-container > div > img {
  width: 540px;
}

/* @media only screen and (min-width: 1904px) {
 .section-image-container > div {
    text-align: right;
  }
  .section-image-container > div > img {
    width: 540px;
  }
} */

@media only screen and (min-width: 1264px) {
  /* LG */
  .section-image-container > div {
    text-align: right;
  }
  .section-image-container > div > img {
    width: 510px;
  }
}
@media only screen and (min-width: 960px) {
  /* MD */
  .section-image-container > div {
    text-align: right;
  }
  .section-image-container > div > img {
    width: 450px;
  }
}
@media only screen and (max-width: 959px) {
  .section-image-container > div {
    text-align: center;
  }
  .section-image-container > div > img {
    width: 330px;
    margin-top: 10px;
  }
}
</style>

<script setup>
import { ref } from "vue";
import LeadershipCards from "../LeadershipCards.vue";
import LeadershipModal from "../LeadershipModal.vue";

const leadershipModal = ref(null);

const openInNewTab = (url) => {
  window.open(url, "_blank");
};

const onLeadershipClick = (p) => {
  leadershipModal.value?.open(p);
};
</script>
